export const SELECT_ROW_SET = 'SELECT_ROW_SET';
export const SET_TASK = 'SET_TASK';
export const SET_VIEW_FIELD = 'SET_VIEW_FIELD';